<template>
  <div class="e-base-input">
    <div class="relative">
      <input
        :id="id"
        v-model="inputValue"
        :type="type"
        :required="required"
        :aria-required="required"
        :aria-invalid="error"
        :placeholder="placeholder"
        :aria-describedby="error ? `${id}-error` : undefined"
        :class="[
          'w-full h-12 px-4 py-0 border rounded-lg bg-white text-black focus:outline-none transition-colors duration-200',
          error ? 'border-[#E72318] border-2' : 'border-[#B8B8B8]',
          !label
            ? 'placeholder:opacity-100 py-2'
            : 'placeholder:opacity-0 pt-4',
        ]"
        :disabled="disabled"
        @focus="handleFocus"
        @blur="handleBlur"
      />

      <label
        v-if="label"
        :for="id"
        :class="[
          'absolute left-[17px] text-[#161616A6] transition-all duration-200 pointer-events-none origin-left',
          hasValue || isFocused
            ? 'top-1.5 text-xs'
            : 'top-1/2 -translate-y-1/2 text-sm',
        ]"
      >
        {{ label }}{{ required ? '*' : '' }}
      </label>
    </div>
    <ErrorMessage
      v-if="error && errorMessage"
      :id="`${id}-error`"
      class="mt-2"
      role="alert"
      aria-live="polite"
    >
      {{ errorMessage }}
    </ErrorMessage>
  </div>
</template>

<script setup lang="ts">
import ErrorMessage from '~/components/elements/ErrorMessage/index.vue'
interface Props {
  id: string
  label?: string
  placeholder: string
  type?: 'text' | 'email' | 'number' | 'tel'
  required?: boolean
  disabled?: boolean
  error?: boolean
  errorMessage?: string
}

const props = withDefaults(defineProps<Props>(), {
  type: 'text',
  required: false,
  disabled: false,
  error: false,
  errorMessage: '',
  label: '',
  placeholder: '',
})

const inputValue = defineModel<string | number>({ default: '' })
const isFocused = ref(false)

const hasValue = computed(() => {
  return inputValue.value !== '' && inputValue.value != null
})

const handleFocus = () => {
  isFocused.value = true
}

const handleBlur = () => {
  isFocused.value = false
}
</script>
